import type { CleanupAction } from "@/lib/api";

const STYLES: Record<CleanupAction, { label: string; className: string }> = {
  KEEP: {
    label: "Keep",
    className: "bg-curate-success/10 text-curate-success border-curate-success/20",
  },
  ARCHIVE: {
    label: "Archive",
    className: "bg-curate-warn/10 text-curate-warn border-curate-warn/30",
  },
  CONSOLIDATE: {
    label: "Consolidate",
    className: "bg-curate-primary/10 text-curate-primary border-curate-primary/25",
  },
  REASSIGN_OWNER: {
    label: "Reassign owner",
    className: "bg-curate-accent/15 text-curate-ink border-curate-accent/30",
  },
  DELETE_HARD: {
    label: "Delete",
    className: "bg-curate-danger/10 text-curate-danger border-curate-danger/30",
  },
};

export function ActionBadge({ action }: { action: CleanupAction }) {
  const s = STYLES[action];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-2xs font-medium ${s.className}`}
    >
      {s.label}
    </span>
  );
}
